import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Button,
  CardContent,
  CardActions,
  Card,
  Typography,
  Backdrop,
  CircularProgress,
  Snackbar,
  SnackbarContent,
  Paper,
  Checkbox,
  Box,
} from "@mui/material";
import { createCheckout } from "../../actions/auth_actions";
import { ReactComponent as SmLogo } from "../Common/Logo/smLogo.svg";
import { useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";

const seatOptions = [
  {
    id: "seat1",
    title: "1 Seat",
    price: "£50",
    annualPrice: "£600"
  },
  {
    id: "seat3",
    title: "3 Seats",
    price: "£100",
    annualPrice: "£1200",
  },
  {
    id: "seat10",
    title: "10 Seats",
    price: "£200",
    annualPrice: "£2400"
  }
]

const creditOptions = [
  {
    id: "bundle250",
    title: "250 Credits",
    price: "£500"
  },
  {
    id: "bundle500",
    title: "500 Credits",
    price: "£800"
  },
  {
    id: "bundle1000",
    title: "1,000 Credits",
    price: "£1,500"
  },
  {
    id: "bundle3000",
    title: "3,000 Credits",
    price: "£4,000"
  },
  {
    id: "bundle5000",
    title: "5,000 Credits",
    price: "£5,000"
  },
  {
    id: "bundle10000",
    title: "10,000 Credits",
    price: "£6,000"
  }
]

const SeatProduct = ({ seat, selectedSeat, setSelectedSeat }) => {
  const {id, title, price} = seat;
  return (
    <Grid item sx={{ m: 0.625 }} onClick={() => {
      if(selectedSeat && selectedSeat.id === id){
        setSelectedSeat(undefined)
      }
      else{
        setSelectedSeat(seat)
      }
    }}>
      <Card sx={{
        background: selectedSeat ? (selectedSeat.id === id ? "#F5F5F7" : "#ff6a1405") : 'inherit',
        border: selectedSeat && selectedSeat.id === id ? "0.1em solid #FF9800" : 'none',
        '&:hover': {
          backgroundColor: "#ffb780",
          cursor: "pointer"
        }
      }}>
        <CardContent>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "20px", textTransform: "uppercase", fontWeight: 700 }}>{title}</Typography>
          <Typography sx={{ display: "flex", alignItems: "baseline", fontFamily: "Montserrat, sans-serif", fontSize: "48px", textTransform: "uppercase", fontWeight: 700 }}>
            {price}
            <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "16px", textTransform: "lowercase", fontWeight: 500 }}>
              {"/month"}
            </Typography>
          </Typography>
        </CardContent>
        <CardActions>
        </CardActions>
      </Card>
    </Grid>
  )
}

const CreditProduct = ({ credits, selectedCredits, setSelectedCredits }) => {
  const {id, title, price} = credits;
  return (
    <Grid item sx={{ m: 0.625 }} onClick={() => {
      setSelectedCredits(credits)
      if(selectedCredits && selectedCredits.id === id){
        setSelectedCredits(undefined)
      }
      else{
        setSelectedCredits(credits)
      }
    }}>
      <Card sx={{
        background: selectedCredits ? (selectedCredits.id === id ? "#F5F5F7" : "#ff6a1405") : 'inherit',
        border: selectedCredits && selectedCredits.id === id ? "0.1em solid #FF9800" : 'none',
        '&:hover': {
          backgroundColor: "#ffb780",
          cursor: "pointer"
        }
      }}>
        <CardContent sx={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "20px", textTransform: "uppercase", fontWeight: 700 }}>{title}</Typography>
          <Typography sx={{ display: "flex", alignItems: "baseline", fontFamily: "Montserrat, sans-serif", fontSize: "48px", textTransform: "uppercase", fontWeight: 700 }}>
            {price}
          </Typography>
        </CardContent>
        <CardActions>
        </CardActions>
      </Card>
    </Grid>
  )
}

const SuccessPopUp = ({isEmbeded}) => {
  return (
    <Paper elevation={1} sx={{ maxWidth: 800, p: 2.5 }}>
      {isEmbeded && (
        <Box component={SmLogo} sx={{ width: "100%", mb: 2, maxHeight: 160, cursor: "pointer" }} onClick={() => window.top.location.href = "https://www.skillsminer.ai"}/>
      )}
      <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "48px", fontWeight: 700 }}>
        Payment Successful
      </Typography>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "20px", fontWeight: 700 }}>
        You should receive an email receipt shortly.
      </Typography>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "20px", fontWeight: 700 }}>
        Once your order has been processed
        We will contact you via email within the next 48 hours with your credentials to login.
      </Typography>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "20px", fontWeight: 700 }}>
        If you have any questions, please contact us at <Link
            to='#'
            onClick={(e) => {
                window.location.href = "enquiries@skillsminer.ai"
                e.preventDefault();
            }}
        >
            {"enquiries@skillsminer.ai"}
        </Link>
      </Typography>
      {!isEmbeded && (
        <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "14px", fontWeight: 500, textAlign: "center" }}>
          Click <Link to={{ pathname: "https://www.skillsminer.ai"}} target="_blank">{"here"}</Link> to return to our website 
        </Typography>
      )}
    </Paper>
  )
}

const ConfirmPopup = ({ onSubmit }) => {
  const [terms, setTerms] = useState(false);
  return (
    <Paper elevation={1} sx={{ maxWidth: 800, p: 2.5 }}>
      <Box component={SmLogo} sx={{ width: "100%", mb: 2, maxHeight: 160, cursor: "pointer" }} onClick={() => window.top.location.href = "https://www.skillsminer.ai"}/>
      <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "48px", fontWeight: 700 }}>
        Continue to Secure Checkout
      </Typography>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "20px", fontWeight: 700 }}>
        To complete your purchase, you will be redirected to Stripe, our secure payment processor. Stripe handles all payment information according to industry-leading security standards.
      </Typography>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "20px", fontWeight: 700 }}>
        To use and access Skillsminer, you must agree to our the terms of our <Link to={{ pathname: "https://www.skillsminer.ai/privacy-policy/"}} target="_blank">{"Privacy Policy"}</Link> and our <Link to={{ pathname: "https://www.skillsminer.ai/terms-of-use/"}} target="_blank">{"Terms Of Use"}</Link>.
      </Typography>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "20px", fontWeight: 700 }}>
        I accept the terms of the privacy policy and terms of use.
        <Checkbox checked={terms} onChange={() => setTerms(!terms)}/>
      </Typography>
      <Button
        color="primary"
        variant="contained"
        size="large"
        disabled={!terms}
        onClick={async () => await onSubmit()}
      >
        <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "16px", fontWeight: 700, textTransform: "capitalize" }}>Continue to payment</Typography>
      </Button>
      <Typography sx={{ p: 1.25, fontFamily: "Montserrat, sans-serif", fontSize: "14px", fontWeight: 500, textAlign: "center" }}>
        If you have any questions, please contact us at <Link
            to='#'
            onClick={(e) => {
                window.location.href = "enquiries@skillsminer.ai"
                e.preventDefault();
            }}
        >
            {"enquiries@skillsminer.ai"}
        </Link>
      </Typography>
    </Paper>
  )
}

const PricingTable = () => {
  const recaptchaRef = useRef(null);
  const dispatch = useDispatch();

  const [successEvent, setSuccessEvent] = useState(false);
  const [selectedSeat, setSelectedSeat] = useState(undefined);
  const [selectedCredits, setSelectedCredits] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [isEmbeded, setIsEmbeded] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);

  useEffect(() => {
    if (window.location !== window.top.location) {
      document.body.style.background = "transparent"
      setIsEmbeded(true);
    }

    let queryDict = {}
    window.location.search.substr(1).split("&").forEach(function(item) {queryDict[item.split("=")[0]] = item.split("=")[1]})
    if(queryDict && queryDict.stripesuccess){
      setSuccessEvent(true);
    }
  }, []);

  const submit = async () => {
    let recaptchaValue = recaptchaRef.current ? recaptchaRef.current.getValue() : false;

    setLoading(true);
    if(!recaptchaValue){
      setLoading(false);
      setErrorMessage("Please complete the captcha");
    }
    else{
      const checkoutURL = await dispatch(createCheckout(selectedSeat, selectedCredits, recaptchaValue));
      if(checkoutURL.url){
        setLoading(false);
        setConfirmPopup(false);
        window.top.location.href = checkoutURL.url;
      }
      else{
        setLoading(false);
        setErrorMessage(checkoutURL.error);
      }
    }
  };

  return (
    <Box sx={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      {loading && (
        <Backdrop sx={{ zIndex: 9000 }} open={true}>
          <CircularProgress size={28} />
        </Backdrop>
      )}
      {successEvent && (
        <Backdrop sx={{ zIndex: 8001 }} open={true}>
          <SuccessPopUp isEmbeded={isEmbeded} />
        </Backdrop>
      )}
      {confirmPopup && (
        <Backdrop sx={{ zIndex: 8000 }} open={true}>
          <ConfirmPopup isEmbeded={isEmbeded} onSubmit={async () => await submit()} />
        </Backdrop>
      )}
      <Snackbar
        sx={{ mt: 1.25 }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={!!errorMessage}
        onClose={() => setErrorMessage(false)}
        autoHideDuration={3000}
        ContentProps={{ "aria-describedby": "message-id" }}
      >
        <SnackbarContent
          sx={{ backgroundColor: 'error.dark' }}
          aria-describedby="client-snackbar"
          message={<span id="message-id">{errorMessage}</span>}
        />
      </Snackbar>
      <Grid
        sx={{ maxWidth: isEmbeded ? "100%" : "800px" }}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
        spacing={0}
      >
        {!isEmbeded && (
          <Box component={SmLogo} sx={{ width: "100%", mb: 2, maxHeight: 160, cursor: "pointer", mt: 2.5 }} onClick={() => window.top.location.href = "https://www.skillsminer.ai"} />
        )}
        <Grid item sx={{ m: 0.625 }}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "28px", textTransform: "uppercase", fontWeight: 500 }}>
            Mine, Match and Mobilise Hidden Talent
          </Typography>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "22px", fontWeight: 500 }}>
            In just a few clicks you can access the power of Skillsminer and find the talent you need
          </Typography>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "18px", fontWeight: 500 }}>
            Each Account gives one member of your team access to Skillsminer's ProAct portal. Then they can mine for matches with your vacant roles. You’ll be able to mine your own talent pool and our exclusive Skillsminer talent pool. You can create vacancies and personalise your own virtual assistant to contact your matches for you.
          </Typography>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
            {seatOptions.map((item) => (
              <SeatProduct
                key={item.id}
                seat={item}
                selectedSeat={selectedSeat}
                setSelectedSeat={setSelectedSeat}
              />
            ))}
          </Grid>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "12px", fontWeight: 500 }}>
            Seat prices are billed annually, providing access for the entire year.
          </Typography>
        </Grid>

        <Grid item sx={{ m: 0.625 }}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "18px", fontWeight: 500 }}>
            If you want to mine from an even bigger pool you can buy Credits. This lets you mine and match from an even larger pool of over 3 million talented people from throughout the UK.
          </Typography>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "18px", fontWeight: 500 }}>
            One Credit allows you to download one additional CV and contact details for one, unique matched individual.
          </Typography>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ m: 2.5 }}>
            {creditOptions.map((item) => (
              <CreditProduct
                key={item.id}
                credits={item}
                selectedCredits={selectedCredits}
                setSelectedCredits={setSelectedCredits}
              />
            ))}
          </Grid>
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <ReCAPTCHA
            style={{ marginTop: 15 }}
            ref={recaptchaRef}
            sitekey="6LfkUdoaAAAAACWTV3biAMmcp8JLPQpsuWzrFDMa"
          />
        </Grid>
        <Grid item sx={{ m: 0.625 }}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            disabled={!selectedSeat}
            onClick={() => setConfirmPopup(true)}
          >
            <Typography sx={{ fontFamily: "Montserrat, sans-serif", fontSize: "16px", fontWeight: 700, textTransform: "capitalize" }}>Buy Now</Typography>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PricingTable;
